<template>
  <teleport to="#product-element__popup-container-vue">
    <transition name="fade">
      <div
        class="popup d-flex d-flex_middle d-flex_center d-flex_column"
        v-if="isShow"
      >
        <div class="popup__layout" @click="close()"></div>
        <div
          class="popup__wrap p-16 p-lg-0 scroll scroll_y w-100 active-move-down"
          v-bind:class="{ 'is-active': isAnimate }"
        >
          <div
            :class="breakpointString"
            class="popup__block bg-white radius-md p-20 mx-auto radius-lg-top-lr-md"
          >
            <div class="popup__content mx-auto">
              <div class="grid-row d-flex_middle d-flex_reverse">
                <div class="grid-col">
                  <div class="btn color-gray hover-color-dark" @click="close()">
                    <Icon iconName="icon-close" className="icon-24" />
                  </div>
                </div>

                <div class="grid-col grid-col_full">
                  <div class="fw-medium" v-if="this.title?.length > 0">
                    {{ this.title }}
                  </div>
                </div>
              </div>

              <div class="fs-14 py-12" v-if="this.picture?.length > 0">
                <img :src="this.picture" :alt="this.title" />
              </div>
              <div class="fs-14 py-12">
                <slot> Идет загрузка .. </slot>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script>
import Icon from "../Icon/Icon.vue";

export default {
  name: "Action",
  components: {
    Icon,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    picture: {
      type: String,
      default: "",
    },
    breakpoint: {
      type: String,
      default: "md",
    },
  },
  data() {
    return {
      isShow: false,
      isAnimate: false,
    };
  },
  methods: {
    show() {
      this.isShow = true;
      setTimeout(() => {
        this.isAnimate = true;
      }, 2);
    },
    close() {
      this.isAnimate = false;
      setTimeout(() => {
        this.isShow = false;
      }, 150);
    },
  },
  computed: {
    breakpointString() {
      return "popup__block_" + this.breakpoint;
    },
  },
};
</script>

<!-- <style lang="scss">
@import "./popup.scss";
</style> -->
